import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { Input, IDropdownOption, Icon } from "@treelab/panda";

import FormItem from "../FormItem";

import { IFormItemChangeValue } from "../../../../types/form-type";

import { ErrorContainer, ContainerMixin, IconContainer } from "./styled";

interface IProps {
  value: string;
  id: string;
  onChange: (value: IFormItemChangeValue) => void;
  options: IDropdownOption[];
  validates?: {
    checkFunc: (data: any) => boolean;
    errorMessageId: string;
  }[];
  labelId?: string;
  isFormattedMessage?: boolean;
  includeSearch?: boolean;
  usePinyinSearch?: boolean;
}

const Select: React.FC<IProps> = ({ value, id, onChange, options, validates, labelId, isFormattedMessage, includeSearch, usePinyinSearch }) => {
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (Array.isArray(validates) && validates.length > 0) {
      let checkError: string = "";
      validates.forEach((item) => {
        const { checkFunc, errorMessageId } = item;
        if (!checkFunc({ value, options, id })) {
          checkError = errorMessageId;
          return;
        }
      });
      setError(checkError);
    }
  }, [value, id, options, validates]);

  const handleChange = (value: string) => {
    onChange({ [id]: value });
  };

  return (
    <FormItem id={id} childrenMixin={ContainerMixin} labelId={labelId}>
      <Input.Select
        input={{
          value,
          name: id,
          onChange: handleChange,
        }}
        placement="bottom-end"
        options={options}
        renderValue={(value: string | null) => {
          if (!value) return "";
          if (!Array.isArray(options) || options.length === 0) return "";
          const targetOption = options.find((item) => item.value === value);
          if (!targetOption) return "";
          return (
            <>
              {targetOption.icon && (
                <IconContainer>
                  <Icon icon={targetOption.icon} />
                </IconContainer>
              )}
              {isFormattedMessage ? <FormattedMessage id={targetOption.name} /> : targetOption.name}
            </>
          );
        }}
        renderItem={(option: IDropdownOption): React.ReactNode => {
          const { value, name, icon } = option;
          return (
            <>
              {icon && (
                <IconContainer>
                  <Icon icon={icon} />
                </IconContainer>
              )}
              {isFormattedMessage ? <FormattedMessage key={value} id={name} /> : name}
            </>
          );
        }}
        itemSize="large"
        meta={{}}
        includeSearch={includeSearch}
        usePinyinSearch={usePinyinSearch}
      />
      {error && (
        <ErrorContainer>
          <FormattedMessage id={error} />
        </ErrorContainer>
      )}
    </FormItem>
  );
};

export default Select;
